export default __webpack_public_path__ + "static/banner-renovation-5-projects-dbf5e19de895dd202d11a1209a99d207.jpg";